/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FullName
 */
export interface FullName {
}

/**
 * Check if a given object implements the FullName interface.
 */
export function instanceOfFullName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FullNameFromJSON(json: any): FullName {
    return FullNameFromJSONTyped(json, false);
}

export function FullNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullName {
    return json;
}

export function FullNameToJSON(value?: FullName | null): any {
    return value;
}

